




















































































































import {Emit, Prop, Vue, Component, Watch} from 'vue-property-decorator';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import OtaruSearchDestroyItemDialog from '@/views/custom/otaru/destroy/OtaruSearchDestroyItemDialog.vue';
import {期限切れ破棄破損初期値, 期限切れ破棄破損型, 期限切れ破棄破損新規初期値} from '@/type/custom/otaru/destroy/otaruDestroy.ts';
import {期限切れ破棄破損ダイアログ種類型} from '@/type/custom/otaru/destroy/otaruDestroyDialog.ts';
import otaruDestroyApi from '@/infrastructure/api/custom/otaru/OtaruDestroyApi.ts';
import {progress} from '@/script/progress';
import moment from 'moment';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {期限切れ破棄破損採用品初期値, 期限切れ破棄破損採用品型} from '@/type/custom/otaru/destroy/item.ts';
import 期限切れ破棄破損チェッカー from '@/type/custom/otaru/destroy/validator/期限切れ破棄破損チェッカー.ts';
import api from '@/infrastructure/api/api';
import {loginModule} from '@/store/authentication/login';

@Component({
  components: {
    ItemSearchDialog: OtaruSearchDestroyItemDialog,
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalDialog,
    AmountField,
    AlertDialog,
  },
})
export default class OtaruRegisterDestroyDialog extends Vue {

  期限切れ破棄破損: 期限切れ破棄破損型 = 期限切れ破棄破損初期値();

  期限切れ破棄破損採用品: 期限切れ破棄破損採用品型 = 期限切れ破棄破損採用品初期値();

  入力JANコード: string = '';

  アラートメッセージ: string[] | string | null = null;

  checker: 期限切れ破棄破損チェッカー | null = null;

  // beforeOpenが処理済か否か
  // NOTE: 複写時に合計金額を空白にしたいためにフラグにて計算すべきかを管理する
  beforeOpened: boolean = false;

  @Prop()
  選択期限切れ破棄破損ダイアログ種類!: 期限切れ破棄破損ダイアログ種類型;

  get 期限切れ破棄破損ダイアログ種類(): 期限切れ破棄破損ダイアログ種類型 {
    if (!this.選択期限切れ破棄破損ダイアログ種類) return new 期限切れ破棄破損ダイアログ種類型('', false, null);
    return this.選択期限切れ破棄破損ダイアログ種類;
  }

  @Emit('close')
  閉じる(再検索: boolean): boolean {
    this.checker = null;
    this.beforeOpened = false;
    return 再検索;
  }

  @Watch('期限切れ破棄破損.バラ数')
  バラ数が変更される() {
    if (!this.beforeOpened) return;
    this.合計金額を計算する();
  }

  @Watch('期限切れ破棄破損.単価')
  単価が変更される() {
    if (!this.beforeOpened) return;
    this.合計金額を計算する();
  }

  get 更新である(): boolean {
    if (!this.期限切れ破棄破損ダイアログ種類.選択期限切れ破棄破損シーケンス番号) return false;
    if (this.期限切れ破棄破損ダイアログ種類.複写である) return false;
    return true;
  }

  合計金額を計算する() {
    if (!this.期限切れ破棄破損.バラ数) {
      this.期限切れ破棄破損.金額 = 0;
      return 0;
    }
    if (!this.期限切れ破棄破損.単価) {
      this.期限切れ破棄破損.金額 = 0;
      return 0;
    }
    this.期限切れ破棄破損.金額 = Math.round(this.期限切れ破棄破損.バラ数 * this.期限切れ破棄破損.単価 * 1000) / 1000;
  }

  async beforeOpen() {
    if (!this.選択期限切れ破棄破損ダイアログ種類.選択期限切れ破棄破損シーケンス番号) {
      // 新規の場合
      this.期限切れ破棄破損 = 期限切れ破棄破損新規初期値();
      this.期限切れ破棄破損採用品 = 期限切れ破棄破損採用品初期値();
      this.入力JANコード = '';
      this.beforeOpened = true;
      return;
    }

    this.期限切れ破棄破損 = 期限切れ破棄破損初期値();
    this.期限切れ破棄破損採用品 = 期限切れ破棄破損採用品初期値();
    this.入力JANコード = '';

    if (this.選択期限切れ破棄破損ダイアログ種類.選択期限切れ破棄破損シーケンス番号) {
      const 期限切れ破棄破損 = await otaruDestroyApi.期限切れ破棄破損を取得する(this.選択期限切れ破棄破損ダイアログ種類.選択期限切れ破棄破損シーケンス番号);
      if (this.期限切れ破棄破損ダイアログ種類.複写である) {
        期限切れ破棄破損.処理日 = null;
        期限切れ破棄破損.バラ数 = null;
        期限切れ破棄破損.金額 = null;
      }
      this.期限切れ破棄破損 = {...期限切れ破棄破損};
      this.期限切れ破棄破損採用品 = await otaruDestroyApi.期限切れ破棄破損採用品を商品コードから取得する(this.期限切れ破棄破損.商品コード);
      this.入力JANコード = this.期限切れ破棄破損採用品.JANコード;

      if (this.期限切れ破棄破損ダイアログ種類.複写である) {
        this.処理日にフォーカスする();
      }
      this.beforeOpened = true;
    }
  }

  async 複写時の初期値をセットする() {
    this.期限切れ破棄破損.処理日 = null;
    this.期限切れ破棄破損.バラ数 = null;
  }

  処理日にフォーカスする() {
    const 処理日入力欄 = document.getElementById('処理日');
    if (!処理日入力欄) return;
    const 処理日インプットタグ一覧 = 処理日入力欄.getElementsByTagName('input');
    if (処理日インプットタグ一覧.length === 0) return;
    処理日インプットタグ一覧[0].focus();
  }

  async 採用品検索モーダルを開く(): Promise<void> {
    this.$modal.show('期限切れ破棄破損採用品検索画面');
  }

  public 採用品検索モーダルを閉じる(): void {
    this.$modal.hide('期限切れ破棄破損採用品検索画面');
  }

  入力エラー判定(項目名: string): boolean {
    if (this.checker == null) return false;
    return this.checker.hasError(項目名);
  }

  async 確定する() {
    this.checker = new 期限切れ破棄破損チェッカー(this.期限切れ破棄破損);
    if (this.checker.hasErrors()) {
      this.showAlert(this.checker.errorMessages());
      return;
    }
    if (this.更新である) {
      await progress(this.期限切れ破棄破損を更新する)
          .then(() => {
            this.閉じる(true);
          })
          .catch((error: any) => {
            if (error.data.errors) {
              return this.showAlert(error.data.errors);
            }
            if (error.data.message && !error.data.errors) {
              return this.showAlert([error.data.message]);
            }
          });
      return;
    }
    await progress(this.期限切れ破棄破損を登録する)
        .then(() => {
          this.閉じる(true);
        })
        .catch((error: any) => {
          if (error.data.errors) {
            return this.showAlert(error.data.errors);

          }
          if (error.data.message && !error.data.errors) {
            return this.showAlert([error.data.message]);
          }
        });
  }

  async 期限切れ破棄破損を登録する() {
    await otaruDestroyApi.期限切れ破棄破損を登録する(this.期限切れ破棄破損);
  }

  async 期限切れ破棄破損を更新する() {
    await otaruDestroyApi.期限切れ破棄破損を更新する(this.期限切れ破棄破損);
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('アラート');
  }

  async 期限切れ破棄破損採用品を取得する() {
    this.期限切れ破棄破損採用品 = 期限切れ破棄破損採用品初期値();
    this.期限切れ破棄破損.商品コード = '';
    this.期限切れ破棄破損.バラ単位区分 = '';

    if (this.入力JANコード.length < 8) return;

    await otaruDestroyApi.期限切れ破棄破損採用品をJANコードから取得する(this.入力JANコード)
      .then((response) => {
        this.選択した採用品の内容を入力する(response);
      });
  }

  選択した採用品の内容を入力する(採用品: 期限切れ破棄破損採用品型) {
    this.$modal.hide('期限切れ破棄破損採用品検索画面');
    this.期限切れ破棄破損採用品 = 採用品;
    this.入力JANコード = 採用品.JANコード;
    this.期限切れ破棄破損.商品コード = 採用品.商品コード;
    this.期限切れ破棄破損.バラ単位区分 = 採用品.バラ単位区分;
    this.期限切れ破棄破損.単価 = 採用品.単価;
    this.期限切れ破棄破損.箱単価 = 採用品.箱単価;
    this.期限切れ破棄破損.数量単位 = 採用品.数量単位;

    this.期限切れ破棄破損.バラ数 = 0;
  }
}
